import { render, staticRenderFns } from "./DialogReasignarConcepto.vue?vue&type=template&id=5b8bc03d&"
import script from "./DialogReasignarConcepto.vue?vue&type=script&lang=js&"
export * from "./DialogReasignarConcepto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports